// Visual theme editor (specs 20).
const veEn = {
  "ve.title": "Theme editor",
  "ve.back": "Back to themes",
  "ve.save": "Save",
  "ve.saved": "Saved — your changes are live on this theme",
  "ve.preview": "Store preview",
  "ve.device": "Preview size",
  "ve.device.desktop": "Desktop",
  "ve.device.tablet": "Tablet",
  "ve.device.mobile": "Mobile",
  "ve.device.full": "Full width",
  "ve.preview_language": "Preview language",
  "ve.undo": "Undo",
  "ve.redo": "Redo",
  "ve.inspector": "Select on page",
  "ve.more": "More",
  "ve.edit_code": "Edit code",
  "ve.share_preview": "Copy preview link (7 days)",
  "ve.share_copied": "Preview link copied. It works for 7 days.",
  "ve.open_preview": "Open preview in new tab",
  "ve.discard": "Discard changes",
  "ve.discard_title": "Discard unsaved changes?",
  "ve.discard_body": "Everything since the last save is removed, for everyone editing this theme.",
  "ve.save_before_publish": "Save your changes before publishing.",
  "ve.stale": "The theme's files changed since these unsaved changes were started (code editor or another save). Check the preview before saving.",
  "ve.changed_by": "{who} changed this theme",
  "ve.tab.sections": "Sections",
  "ve.tab.settings": "Theme settings",
  "ve.template": "Template",
  "ve.custom_page_note": "Custom pages are code files. Preview them here; change their layout in the code editor and their content in Storefront › Pages.",
  "ve.liquid_template_note": "This template is a Liquid file, so it has no sections to arrange. Preview it here or change it in the code editor.",
  "ve.settings_panel": "Settings",
  "ve.no_settings": "No settings here.",
  "ve.feature_off": "feature off",
  "ve.duplicate": "Duplicate",
  "ve.remove": "Remove",
  "ve.remove_static_title": "Remove this section?",
  "ve.remove_static_body": "This section can't be added again from the section library. Undo brings it back until you save.",
  "ve.add_section": "Add section",
  "ve.add_block": "Add block",
  "ve.add_named": "Add {name}",
  "ve.search_sections": "Search sections",
  "ve.no_sections": "No more sections can be added here.",
  "ve.show": "Show",
  "ve.hide": "Hide",
  "ve.expand": "Show blocks",
  "ve.collapse": "Hide blocks",
  "ve.drag": "Drag {name}",
  "ve.create_template": "Create template",
  "ve.search_templates": "Search templates",
  "ve.preview_only": "preview only",
  "ve.custom_page": "Custom page",
  "ve.template_for": "Template for",
  "ve.template_name": "Name",
  "ve.template_name_hint": "Lowercase letters, numbers, - and _. Assign it to products, collections or pages from their pages.",
  "ve.based_on": "Start from",
  "ve.default_template": "Default template",
  "ve.tpl.index": "Home page",
  "ve.tpl.product": "Products",
  "ve.tpl.collection": "Collections",
  "ve.tpl.list-collections": "Collections list",
  "ve.tpl.page": "Pages",
  "ve.tpl.blog": "Blogs",
  "ve.tpl.article": "Blog posts",
  "ve.tpl.cart": "Cart",
  "ve.tpl.search": "Search",
  "ve.tpl.404": "Page not found",
  "ve.tpl.password": "Password",
  "ve.code_setting_locked": "Only staff who can edit code can change this.",
  "ve.align.left": "Left",
  "ve.align.center": "Center",
  "ve.align.right": "Right",
  "ve.low_contrast": "Low contrast ({ratio}:1). Aim for at least 4.5:1 so text stays readable.",
  "ve.link_choose": "Choose a link",
  "ve.link_title": "Link to",
  "ve.clear": "Clear",
  "ve.link_unsafe": "Use a link starting with https://, mailto:, tel: or /.",
  "ve.use_link": "Use this link",
  "ve.anchor_hint": "Links to a section on the same page by its id.",
  "ve.search": "Search",
  "ve.no_results": "Nothing found.",
  "ve.linkcat.fixed": "Store pages",
  "ve.linkcat.product": "Products",
  "ve.linkcat.collection": "Collections",
  "ve.linkcat.page": "Pages",
  "ve.linkcat.custom_page": "Custom pages",
  "ve.linkcat.blog": "Blogs",
  "ve.linkcat.article": "Blog posts",
  "ve.linkcat.policy": "Policies",
  "ve.linkcat.url": "Web address",
  "ve.linkcat.anchor": "Section on this page",
  "ve.link.home": "Home page",
  "ve.link.catalog": "All products",
  "ve.link.collections": "All collections",
  "ve.link.search": "Search",
  "ve.link.cart": "Cart",
  "ve.link.account": "Customer account",
  "ve.link.product": "Product",
  "ve.link.collection": "Collection",
  "ve.link.page": "Page",
  "ve.link.blog": "Blog",
  "ve.link.article": "Blog post",
  "ve.link.policy": "Policy",
  "ve.link.custom_page": "Custom page",
  "ve.link.anchor": "Section",
  "ve.link.url": "Web address",
  "ve.pick.product": "Choose a product",
  "ve.pick.collection": "Choose a collection",
  "ve.pick.blog": "Choose a blog",
  "ve.pick.page": "Choose a page",
  "ve.pick.article": "Choose a blog post",
  "ve.none": "None",
  "ve.file_choose": "Choose file",
  "ve.change": "Change",
  "ve.images": "Images",
  "ve.videos": "Videos",
  "ve.upload": "Upload",
  "ve.no_files": "No files yet. Upload one.",
};
export default veEn;
